import EditContributionType from '../../../../banking/components/income-split/editor/subscreens/EditContributionType';

export default function IncomeSplitEditContributionTypeScreen() {
    return <EditContributionType />;
}
